import { Actions, Root } from 'firestar'

interface AppSettings extends Root{
   minimumBuildNumber: number
}

namespace Settings {

   export async function getAppSettings() {
      return new Promise<AppSettings | undefined>(async (resolve, reject) => {
         try {
            const appSettings = await Actions.readDocument<AppSettings>('settings/app')
            resolve(appSettings)
         } catch (error) {
            reject(error)
         }
      })
   }
}

export default Settings